import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkItemLaneModule } from 'components/work-item-lane-list/work-item-lane/work-item-lane.module';
import { TranslateModule } from '@ngx-translate/core';
import { WorkItemLaneListComponent } from 'components/work-item-lane-list/work-item-lane-list.component';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';

@NgModule({
  imports: [
    CommonModule,
    WorkItemLaneModule,
    TranslateModule.forChild(),
    SvgIconModule
  ],
  declarations: [
    WorkItemLaneListComponent
  ],
  exports: [
    WorkItemLaneListComponent
  ]
})
export class WorkItemLaneListModule {}
